import Vue from 'vue';
const formShape = {
  idNumber: null,
  isSecurity: false,
  trayRequired: false
};

export default Vue.extend({
  template: `
        <span>
            <b-button type="submit"   variant="dark" v-on:click="invokeExitStatus" :disabled="submitted">Update Exit Status</b-button>
        </span>
    `,
  data: function() {
    return {
      form: Object.assign({}, formShape),
      submitted: false
    };
  },
  beforeMount() {},
  mounted() {},

  methods: {
    invokeExitStatus() {
      console.log(this.params.value);
      if(this.params.value != null){
        this.submitted = true;
        this.form.idNumber = this.params.value;
        let exitParams = JSON.stringify(this.form);
        console.log(exitParams);
        this.$nextTick(() => {
          let params = JSON.stringify(this.form);
          this.$store.dispatch('samadh/updateVisitStatus', exitParams)
            .then((response) => {
                if(response.data.success == false){
                  this.showErrorMsg({
                    message: response.data.error
                  });
                }
                else{
                  this.showSuccessMsg({
                    message: 'Record updated successfully.'
                  });
                }
            })
            .catch((error) => {
              if (error.response.status == 400) {
                this.showErrorMsg({
                  message: error.response.data.message
                })
              }
              else if (error.response.status == 422){
                  this.showErrorMsg({
                    message: error.response.data.message
                  });
              }
              else {
                this.showErrorMsg()
              }
              this.submitted = false;

            })


        });
      }
    },
  },
});
